import React, { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { DataTable } from 'components/ui/DataTable';
import { useColumns } from './columns';
import { MainContainer } from 'components/shared';
import { SettingLayout } from 'layouts/SettingLayout';
import { InnerOptions } from '../InnerOptions';
import { useHubVehicle } from 'hooks/api';
import { useFilterStore, usePaginationStore } from 'store/hub/hubVehicle';
import { useErrorHandler } from 'exceptions/ErrorHandler';
import { HubDeleteVehicle } from '../Delete';
import { DataFilter } from './DataFilter';

import { IHubVehicle } from 'interfaces/Hub';

import { RootStateOrAny, useSelector } from 'react-redux';
import { AuthState } from 'store/ducks/auth';

export const HubListVehicle: React.FC = () => {
  const { options } = InnerOptions();
  const navigate = useHistory();
  const { errorHandler } = useErrorHandler();
  const { filtersData } = useFilterStore();
  const { pagination, setPagination } = usePaginationStore();
  const { getListVehicles } = useHubVehicle();
  const [toDelete, setToDelete] = useState<IHubVehicle | null>(null);

  const { data: userData } = useSelector<RootStateOrAny>(
    (state) => state.auth
  ) as AuthState;

  const handleDelete = (dataToDelete: IHubVehicle) => {
    setToDelete(dataToDelete);
  };

  const { columns } = useColumns({ deleteFunc: handleDelete });

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['getListVehicles', filtersData, pagination],
    queryFn: () =>
      getListVehicles(
        { ...filtersData, carrier_cnpj_root: userData?.rootCarrier },
        pagination
      ),
    onError: errorHandler,
  });

  const onCloseDelete = useCallback(() => {
    setToDelete(() => null);
    refetch();
  }, [refetch]);

  const handlerPageEdit = useCallback(
    (row: any) => {
      navigate.push(`/settings/hub-vehicles/edit/${row.original.id}`);
    },
    [navigate]
  );

  return (
    <MainContainer>
      <SettingLayout options={options} page="hub-vehicles">
        <DataFilter />
        {toDelete && (
          <HubDeleteVehicle
            isOpen={!!toDelete}
            data={toDelete}
            onClose={onCloseDelete}
          />
        )}
        <section>
          <DataTable
            data={data?.vehicles ?? []}
            isLoading={isLoading}
            columns={columns}
            manualPagination={true}
            pagination={data?.pagination ?? {}}
            onPaginationChange={setPagination}
            showControlColumns={false}
            onRowClick={(row) => handlerPageEdit(row)}
          />
        </section>
      </SettingLayout>
    </MainContainer>
  );
};
